import React, { Component } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';

import { MenuItem } from 'react-bootstrap';
import DropdownButton from 'react-bootstrap/lib/DropdownButton';
import styles from '../../styles/components/secondary-menu.scss';

import { getParamsFromWindowLocationSearch } from '../../../helper.js';
import PriceForm from '../price-form';
import ClearFilter from '../clear-filter';
import SubmenuTitle from './submenu-title';
import MenuLink from './menu-link';

import ZoneModal from '../../zone/zone-modal';
import translations from '../../../../translations/app-translations.json';
import ZoneService from '../../../services/zone-service';
import Configs from '../../../configs';
import Menu from '../dropdown-build-menu';
import spreeStore from '../../../store';
import MunicipalityService from '../../../services/municipality-service';
import MunicipalitySelectorModal from '../municipality-selector-modal';
import actions from '../../../actions';
import ProductModel from '../../../services/product-model';
import EmptyCartWarningModal from '../empty-cart-warning-modal';

class SecondaryMenu extends Component {
    constructor(props) {
        super(props);
        this.defaultMunicipality = {
            id: -1,
            name: this.props.intl.formatMessage({
                id: 'select',
                defaultMessage: 'Select',
            }),
        };

        const eligibleMunicipalities = MunicipalityService.getAvailableMunicipalitiesByZoneId(this.props.currentZone, this.props.availableZones, this.props.availableMunicipalities);
        const targetMunicipality = eligibleMunicipalities.find((mun) => mun.id === this.props.currentMunicipality);
        this.state = {
            showCategory: 1,
            showPrice: 1,
            params: getParamsFromWindowLocationSearch(),
            menu: [],
            showZoneModal: false,
            deployed: false,
            selectedZoneId: props.currentZone || 6,
            pendingPath: '',
            showMunicipalitySelector: false,
            selectedZoneMunicipalities: [],
            paramsToContinue: {},
            municipality: {
                eligibleMunicipalities,
                currentMunicipality: this.props.currentMunicipality && targetMunicipality ? targetMunicipality : this.defaultMunicipality,
            },
            showEmptyCartModalDueToMunicipalityChange: false,
        };

        this.setSelectedIndex = this.setSelectedIndex.bind(this);
        this.setParams = this.setParams.bind(this);
        this.selectShowValue = this.selectShowValue.bind(this);
        this.handleCloseZoneModal = this.handleCloseZoneModal.bind(this);
        this.setSelected = this.setSelected.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.checkAllProdAreAvailables = this.checkAllProdAreAvailables.bind(this);
        this.handleSelectedZone = this.handleSelectedZone.bind(this);
        this.buildMenu = this.buildMenu.bind(this);
    }

    componentDidMount() {
        document.addEventListener('click', this.handleClickOutside);
        this.props.loadGroupedStores().then((groupedStores) => {
            this.buildMenu(groupedStores.zones, groupedStores.data);
        });
    }

    shouldComponentUpdate(nextProps, nextState) {
        const isCurrentStoreValid = this.isCurrentStoreAvailableInCurrentZone();
        return JSON.stringify(nextProps) !== JSON.stringify(nextState) || !isCurrentStoreValid;
    }

    componentDidUpdate(prevProps) {
        const isCurrentStoreValid = this.isCurrentStoreAvailableInCurrentZone();
        if (!isCurrentStoreValid) {
            const state = spreeStore.getState();
            const currentZone = state.zones.availableZones.find((zone) => zone.id === state.zones.currentZone);
            this.handleSelectedZone(currentZone);
        }
        if (prevProps.currentZone !== this.props.currentZone) {
            const eligibleMunicipalities = MunicipalityService.getAvailableMunicipalitiesByZoneId(this.props.currentZone, this.props.availableZones, this.props.availableMunicipalities);
            const targetMunicipality = this.props.currentMunicipality ? eligibleMunicipalities.find((mun) => mun.id === this.props.currentMunicipality) : undefined;
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState({
                municipality: {
                    eligibleMunicipalities,
                    currentMunicipality: targetMunicipality || this.defaultMunicipality,
                },
            });
        }
        if (prevProps.currentMunicipality !== this.props.currentMunicipality) {
            const eligibleMunicipalities = MunicipalityService.getAvailableMunicipalitiesByZoneId(this.props.currentZone, this.props.availableZones, this.props.availableMunicipalities);
            const targetMunicipality = eligibleMunicipalities.find((mun) => mun.id === this.props.currentMunicipality);
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState((state) => ({
                ...state,
                municipality: {
                    eligibleMunicipalities,
                    currentMunicipality: this.props.currentMunicipality && targetMunicipality ? targetMunicipality : this.defaultMunicipality,
                },
            }));
        }
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.handleClickOutside);
    }

    setSelected = (id, text, to) => {
        // comprobar si todos los productos estan disponibles
        if (this.props.order.line_items.length > 0) {
            this.setState({
                selectedZoneId: id,
                pendingPath: to,
                showZoneModal: true,
            });
        } else {
            const { zones: { availableZones }, municipalities: { availableMunicipalities, currentMunicipality, isMunicipalityPromptModalOpen } } = spreeStore.getState();
            const selectedZoneMunicipalities = MunicipalityService.getAvailableMunicipalitiesByZoneId(id, availableZones, availableMunicipalities);
            if (MunicipalityService.isMunicipalitySelectorModalRequired(currentMunicipality, selectedZoneMunicipalities)) {
                if (!this.state.showMunicipalitySelector && !isMunicipalityPromptModalOpen) {
                    this.setState((state) => ({
                        showMunicipalitySelector: true,
                        selectedZoneMunicipalities,
                        paramsToContinue: { id, text, to },
                    }));
                }
            } else {
                this.props.setCurrentZone(id);
                this.props.history.push(to);
            }
        }
        // comprobar si todos los productos estan disponibles
    }

    setSelectedIndex(index, name) {
        this.setState((state) => ({ ...state, [name]: index }));
    }

    setParams() {
        const params = getParamsFromWindowLocationSearch();
        this.setState((state) => ({ ...state, params }));
    }

    handleClickOutside = (e) => {
        if (e.target.id !== 'dropdown-basic-button' && e.target.className !== 'caret') this.setState((state) => ({ deployed: (state.deployed) ? !state.deployed : state.deployed }));
        else this.setState((state) => ({ deployed: !state.deployed }));
    }

    handleSelectStore = (e) => {
        const storeId = parseInt(e.target.id, 10);
        const selectedStore = this.props.stores.find((store) => store.id === storeId);
        this.props.setCurrentStore(selectedStore);
        this.props.fetchProducts(this.state.params);
    }

    isCurrentStoreAvailableInCurrentZone = () => {
        const state = spreeStore.getState();
        let isCurrentStoreValid = true;
        if (state.stores && state.stores.currentStore && state.stores.currentStore.id && state.stores && Object.keys(state.stores.storesGrouped).length > 0) {
            const currentStoreId = state.stores.currentStore.id;
            const currentZoneId = state.zones.currentZone;
            if (state.stores.storesGrouped.data[currentZoneId]) {
                const storesOfTheCurrentZone = state.stores.storesGrouped.data[currentZoneId];
                isCurrentStoreValid = storesOfTheCurrentZone.find((store) => store.id === currentStoreId) !== undefined;
            }
        }
        return isCurrentStoreValid;
    }

    buildMenu(zones, stores) {
        const tmpMenu = Menu.buildMenu(zones, stores);
        this.setState((prevState) => ({ menu: tmpMenu }));
    }

    checkAllProdAreAvailables() {
        if (!this.props.currentZone) {
            console.log('WARNING: currentZone is NOT available');
            return false;
        }
        if (!this.props.order || !this.props.order.line_items || (this.props.order.line_items.length > 0 && !this.props.order.line_items[0].attributes.zone_ids)) {
            console.log('Order zones are NOT available');
            return false;
        }
        return this.props.order.line_items.length === 0 || this.props.order.line_items.every((item) => item.attributes.zone_ids.some((zone) => zone === this.props.currentZone));
    }

    handleCloseZoneModal(clean) {
        if (clean) {
            this.props.emptyCart(this.props.order, this.props.locale.currentLocale)
                .then(() => {
                    this.props.setCurrentZone(this.state.selectedZoneId);
                    this.props.history.push(this.state.pendingPath);
                })
                .catch((err) => console.log(err));
        }
        this.setState({ showZoneModal: false });
    }

    selectShowValue(type) {
        return type === 'category' ? this.state.showCategory : this.state.showPrice;
    }

    handleSelectedZone(zone) {
        const storesInZone = this.props.storesGrouped.data[zone.id];
        const isStoreInNewZone = storesInZone.find((store) => store.id === this.props.currentStore.id) !== undefined;
        let to = '';

        if (this.props.location.pathname !== '/' && isStoreInNewZone) {
            to = this.props.location.pathname;
        } else if (this.props.location.pathname !== '/') {
            to = storesInZone[0].code;
        } else {
            to = this.props.path;
        }

        this.setSelected(zone.id, zone.name, `${to}?`
            + `${this.state.params.price_min ? `price_min=${this.state.params.price_min}` : ''}`
            + `${this.state.params.price_max ? `&price_max=${this.state.params.price_max}` : ''}`
            + `${this.state.params.category ? `&category=${this.state.params.category}` : ''}`
            + `&zone_id=${zone.id}`);
    }

    handleCloseModalSelectedMunicipality(municipality) {
        spreeStore.dispatch(actions.setCurrentMunicipality(municipality.id));
        const { id, text, to } = this.state.paramsToContinue;
        this.setSelected(id, text, to);
        this.setState({
            showMunicipalitySelector: false,
            paramsToContinue: {},
        });
    }

    handleSelectedMunicipality(municipality) {
        if (municipality.id !== this.state.municipality.currentMunicipality.id) {
            if (this.props.order.line_items.length > 0) {
                this.setState({
                    showEmptyCartModalDueToMunicipalityChange: true,
                    paramsToContinue: municipality,
                });
            } else {
                this.changeMunicipality(municipality);
            }
        }
    }

    handleCloseEmptyCartModal(response) {
        if (response) {
            this.props.emptyCart(this.props.order, this.props.locale.currentLocale)
                .then(() => {
                    const municipality = this.state.paramsToContinue;
                    this.changeMunicipality(municipality);
                    this.setState({
                        showEmptyCartModalDueToMunicipalityChange: false,
                        paramsToContinue: {},
                    });
                    this.props.setCurrentZone(this.state.selectedZoneId);
                    this.props.history.push(this.state.pendingPath);
                })
                .catch((err) => console.log(err));
        } else {
            this.setState({
                showEmptyCartModalDueToMunicipalityChange: false,
                paramsToContinue: {},
            });
        }
    }

    changeMunicipality(municipality) {
        if (municipality) {
            spreeStore.dispatch(actions.setCurrentMunicipality(municipality.id));
            this.setState({
                showMunicipalitySelector: false,
                paramsToContinue: {},
            });
            const { locale: currentLocale } = spreeStore.getState();
            spreeStore.dispatch(actions.displayLoader());
            spreeStore.dispatch(actions.fetchProducts({ page_no: 1, currentLocale })).then((response) => {
                const fetchedProducts = response.body;
                spreeStore.dispatch(actions.addProducts({ products: ProductModel.filterUniqueProducts(fetchedProducts.data), meta: fetchedProducts.meta }));
                spreeStore.dispatch(actions.hideLoader());
            });
        }
    }

    render() {
        const menuStore = !this.props.displayLoader ? this.props.taxons.taxonsMenu.find((taxon) => taxon.store.id === this.props.currentStore.id) : [];

        const menuLevel2 = (taxons, store) => taxons.map((taxon, index) => (
            <MenuLink
                key={taxon.id}
                className={this.state.params.category !== taxon.permalink ? styles.paddingLeft30 : styles.active}
                pathname={this.props.path}
                search={`?category=${taxon.permalink}${this.state.params.price_min && this.state.params.price_max
                    ? `&price_min=${this.state.params.price_min}&price_max=${this.state.params.price_max}`
                    : ''}`}
                isActive={(match, location) => this.state.params.category === taxon.permalink}
                name={taxon.name}
                setParams={this.setParams}
            />
        ));

        const menuLevel1 = (item) => item && item.taxons && []
            .concat(item.taxons)
            .sort((a, b) => (a.rgt > b.rgt ? 1 : -1))
            .map((taxon, index) => (
                <ul key={index}>
                    {taxon.taxons.length !== 0 ? (
                        <SubmenuTitle
                            open
                            isLink={taxon.taxons.length !== 0}
                            key={taxon.taxonCategory.id}
                            className={this.state.params.category === taxon.taxonCategory.permalink ? styles.activeBorder : undefined}
                            pathname={this.props.path}
                            search={`?category=${taxon.taxonCategory.permalink}${this.state.params.price_min && this.state.params.price_max
                                ? `&price_min=${this.state.params.price_min}&price_max=${this.state.params.price_max}`
                                : ''}`}
                            isActive={(match, location) => this.state.params.category === taxon.taxonCategory.permalink}
                            title={taxon.taxonCategory.name}
                            setParams={this.setParams}
                        >
                            {taxon.taxons.length ? menuLevel2(taxon.taxons, item.store) : ''}
                        </SubmenuTitle>
                    ) : (
                        <MenuLink
                            key={taxon.taxonCategory.id}
                            className={this.state.params.category === taxon.taxonCategory.permalink ? styles.activeBorder : undefined}
                            pathname={this.props.path}
                            search={`?category=${taxon.taxonCategory.permalink}${this.state.params.price_min && this.state.params.price_max
                                ? `&price_min=${this.state.params.price_min}&price_max=${this.state.params.price_max}`
                                : ''}`}
                            isActive={(match, location) => this.state.params.category === taxon.taxonCategory.permalink}
                            name={taxon.taxonCategory.name}
                            setParams={this.setParams}
                        />
                    )}
                </ul>
            ));

        const storesInZone = this.props.storesGrouped
        && this.props.storesGrouped.data
        && this.props.storesGrouped.data[this.props.currentZone]
            ? this.props.storesGrouped.data[this.props.currentZone] : [];

        return (
            <div>
                <div className={styles.marginBottom5}>
                    <SubmenuTitle open title={(<FormattedMessage id="zone" defaultMessage="Zone" />)} />
                    <div id="zone-selector" className={styles.leftMenuContent} style={{ padding: 16 }}>
                        <DropdownButton
                            id="dropdown-basic-button"
                            as="button"
                            className="button-cancel button-small button-wide"
                            title={ZoneService.getNameCurrentZone(this.props.availableZones, this.props.currentZone)}
                        >
                            {this.state.menu.map((zone) => (
                                <MenuItem
                                    as="button"
                                    id={zone.id}
                                    key={zone.id}
                                    onClick={() => this.handleSelectedZone(zone)}
                                >
                                    {zone.label}
                                </MenuItem>
                            ))}
                        </DropdownButton>
                    </div>
                    {
                        this.state.municipality.eligibleMunicipalities.length > 0 && (
                            <div id="municipalities_selector" className={styles.leftMenuContent} style={{ paddingLeft: 16, paddingBottom: 16, paddingTop: 0 }}>
                                <DropdownButton
                                    id="dropdown-basic-button"
                                    as="button"
                                    className="button-cancel button-small button-wide"
                                    title={this.state.municipality.currentMunicipality.name}
                                >
                                    {this.state.municipality.eligibleMunicipalities.map((municipality) => (
                                        <MenuItem
                                            as="button"
                                            id={municipality.id}
                                            key={`menu_${municipality.id}`}
                                            onClick={() => this.handleSelectedMunicipality(municipality)}
                                        >
                                            {municipality.name}
                                        </MenuItem>
                                    ))}
                                </DropdownButton>
                            </div>

                        )
                    }

                </div>
                {
                    Configs.SECONDARY_MENU.STORES && (
                        <div className={styles.marginBottom5}>
                            <SubmenuTitle open title={(<FormattedMessage id="store" defaultMessage="Store" />)} />
                            <div className={`${styles.leftMenuContent} ${styles.storeContainer}`}>
                                <DropdownButton
                                    id="dropdown-basic-button"
                                    as="button"
                                    className="button-cancel button-small button-wide"
                                    title={this.props.currentStore.name || ''}
                                >
                                    {
                                        storesInZone.map((store) => (
                                            <MenuLink
                                                key={store.id}
                                                name={store.name}
                                                pathname={`/${store.code}`}
                                            />
                                        ))
                                    }
                                </DropdownButton>
                            </div>
                        </div>
                    )
                }
                {
                    Configs.SECONDARY_MENU.CATEGORIES && (
                        <div className={styles.marginBottom5}>
                            <SubmenuTitle
                                open
                                title={(
                                    <FormattedMessage
                                        id="category"
                                        defaultMessage="Category"
                                    />
                                )}
                            >
                                <div className={styles.leftMenuContent}>
                                    {menuLevel1(menuStore)}
                                    <div className="row" style={{ marginLeft: 15, paddingTop: 5 }}>
                                        <ClearFilter
                                            title={<FormattedMessage id="clear-filter" defaultMessage="Clear Filter" />}
                                            setParams={this.setParams}
                                        />
                                    </div>
                                </div>
                            </SubmenuTitle>
                        </div>
                    )
                }
                <div>
                    <SubmenuTitle
                        open
                        title={(<FormattedMessage id="price" defaultMessage="Price" />)}
                    >
                        <div className={styles.leftMenuContent}>
                            {menuStore && (
                                <ul>
                                    <MenuLink
                                        className={this.state.params.price_min === '0' && this.state.params.price_max === '25' ? styles.activeBorder : undefined}
                                        pathname={this.props.location.pathname !== '/' ? this.props.location.pathname : this.props.path}
                                        search={`?price_min=0&price_max=25${this.state.params.category ? `&category=${this.state.params.category}` : ''}`}
                                        isActive={(match, location) => this.state.params.price_min === '0' && this.state.params.price_max === '25'}
                                        name={`${translations[this.props.locale.currentLocale]['under-price']} $25`}
                                        setParams={this.setParams}
                                        style={{ textTransform: 'none' }}
                                    />
                                    <MenuLink
                                        className={this.state.params.price_min === '25' && this.state.params.price_max === '50' ? styles.activeBorder : undefined}
                                        pathname={this.props.location.pathname !== '/' ? this.props.location.pathname : this.props.path}
                                        search={`?price_min=25&price_max=50${this.state.params.category ? `&category=${this.state.params.category}` : ''}`}
                                        isActive={(match, location) => this.state.params.price_min === '25' && this.state.params.price_max === '50'}
                                        name="$25-$50"
                                        setParams={this.setParams}
                                    />
                                    <MenuLink
                                        className={this.state.params.price_min === '50' && this.state.params.price_max === '75' ? styles.activeBorder : undefined}
                                        pathname={this.props.location.pathname !== '/' ? this.props.location.pathname : this.props.path}
                                        search={`?price_min=50&price_max=75${this.state.params.category ? `&category=${this.state.params.category}` : ''}`}
                                        isActive={(match, location) => this.state.params.price_min === '50' && this.state.params.price_max === '75'}
                                        name="$50-$75"
                                        setParams={this.setParams}
                                    />
                                    <MenuLink
                                        className={this.state.params.price_min === '75' && this.state.params.price_max === '100' ? styles.activeBorder : undefined}
                                        pathname={this.props.location.pathname !== '/' ? this.props.location.pathname : this.props.path}
                                        search={`?price_min=75&price_max=100${this.state.params.category ? `&category=${this.state.params.category}` : ''}`}
                                        isActive={(match, location) => this.state.params.price_min === '75' && this.state.params.price_max === '100'}
                                        name="$75-$100"
                                        setParams={this.setParams}
                                    />
                                    <MenuLink
                                        className={this.state.params.price_min === '100' && this.state.params.price_max === 'undefined' ? styles.activeBorder : undefined}
                                        pathname={this.props.location.pathname !== '/' ? this.props.location.pathname : this.props.path}
                                        search={`?price_min=100${this.state.params.category ? `&category=${this.state.params.category}` : ''}`}
                                        isActive={(match, location) => this.state.params.price_min === '100' && this.state.params.price_max === 'undefined'}
                                        name={`${translations[this.props.locale.currentLocale]['above-price']} $100`}
                                        setParams={this.setParams}
                                        style={{ textTransform: 'none' }}
                                    />
                                </ul>
                            )}
                            <PriceForm
                                setParams={this.setParams}
                                location={this.props.location.pathname !== '/' ? this.props.location.pathname : this.props.pat}
                                submit={this.props.submitPriceForm}
                            />
                        </div>
                    </SubmenuTitle>
                </div>
                <div>
                    <ZoneModal
                        show={this.state.showZoneModal}
                        onHide={this.handleCloseZoneModal}
                    />
                    <MunicipalitySelectorModal
                        isOpen={this.state.showMunicipalitySelector}
                        currentZoneMunicipalities={this.state.selectedZoneMunicipalities}
                        handleClose={(municipality) => this.handleCloseModalSelectedMunicipality(municipality)}
                    />
                    <EmptyCartWarningModal
                        isOpen={this.state.showEmptyCartModalDueToMunicipalityChange}
                        onClose={(response) => this.handleCloseEmptyCartModal(response)}
                        messageId="modal-municipality-text"
                    />
                </div>
            </div>
        );
    }
}

export default withRouter(injectIntl(SecondaryMenu));



/** WEBPACK FOOTER **
 ** ./src/components/shared/secondary-menu/secondary-menu.jsx
 **/